import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IRateType } from "../../utils/types/models";

export default createEntityReducer<IRateType>(Endpoint.RateTypes, Endpoint.RateTypesList);
